import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    ScrollView,
} from "react-native";

import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Text from "../components/Text";
import * as ServerOperations from "../utils/ServerOperations";
let width = Commons.getWidth();
let styles = {};
let isMobile = false;
let scale = 1;
const backIcon = require("../images/Notifications/backArrow.png");
const settingsIcon = require("../images/Notifications/filledSettings.png");
const toggleIcon = require("../images/Notifications/IOSToggle.png");
const toggleSelectedIcon = require("../images/Notifications/notificatoinOn.png");
const checkBoxIcon = require("../images/Notifications/checkBox.png");
const checkBoxSelectedIcon = require("../images/Notifications/selectedCheckBox.png");


class NotificationsSettings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            notifSettings: {},
            turnNotificationsOn: false,
            isOther: false,
            relatedNotif: false,
            stockNotif: false,
            promoNotif: false,
            accountNotif: false,
            criticalAlert: false,
        };
    }
    Pressables = {};

    async componentDidMount() {
        this.loadNotificationsSettings('', '', '', '', '', '', '', '');
    }

    loadNotificationsSettings = async (notifStatus, relatedNotif, stockNotif, promoNotif, accountNotif, criticalAlert, whatsappNotif, appNotif) => {
        let item = await ServerOperations.getSaveUserNotificationSettings(notifStatus, relatedNotif, stockNotif, promoNotif, accountNotif, criticalAlert, whatsappNotif, appNotif);
        this.setState({
            turnNotificationsOn: item.STATUS === 'Y',
            relatedNotif: item.ORDER_RELATED === 'Y',
            stockNotif: item.STOCK === 'Y',
            promoNotif: item.PROMO === 'Y',
            accountNotif: item.ACCOUNT === 'Y',
            criticalAlert: item.CRITICAL === 'Y',
            whatsappNotif: item.WHATSAPP === 'Y',
            appNotif: item.APP === 'Y',
        });

    }


    renderHeader = () => {
        const { isSettings } = this.props;
        return (
            <View style={{
                flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between",
                paddingTop: isMobile ? 20 : 30,
            }}>
                {
                    isMobile && <TouchableOpacity onPress={() => { isSettings(false) }}>
                        <Image source={backIcon} style={{
                            width: 18.667,
                            height: 16,
                            padding: 1,
                            resizeMode: "contain",
                            tintColor: Styles.appColor1
                        }} />
                    </TouchableOpacity>
                }
                {!isMobile && <View style={{ width: 18.667, height: 16 }}></View>}
                <Text style={[AppStyles.notificationText]}>
                    {STRINGS.app_notifications_settings}
                </Text>

                <TouchableOpacity onPress={() => { }}>
                    <Image source={settingsIcon} style={{ width: 21, height: 20, tintColor: Styles.appColor1 }}></Image>
                </TouchableOpacity>
            </View>
        )
    }



    renderMobile() {
        scale = width / 420;
        return (
            <View style={styles.container}>
                {/* {Commons.renderAppHeader({}, this)} */}
                {this.renderHeader()}
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width }}>
                        {Commons.loadFonts(this, false)}
                        {Styles.renderVSeparator(0)}
                        {this.renderPart1Mobile()}
                        {this.renderPart2Mobile()}
                    </View>
                </ScrollView>
                {this.state.isOther && Commons.renderOtherView(this, this.state.isOther)}
                {Commons.renderAppFooter({}, this, '', '', '', '#52C0EE', true)}
            </View >
        );
    }

    render() {
        Commons.resizeHandle(window, this, () => {
            width = this.width;
        });
        width = this.props.width ? this.props.width : Dimensions.get("window").width;
        isMobile = Commons.isMobile();
        if (isMobile) {
            styles = this.styles();
            return this.renderMobile();
        }
        styles = this.styles();
        return (
            <View style={styles.container}>
                {/* {Commons.renderAppHeader({}, this)} */}
                {this.renderHeader()}
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width }}>
                        {Styles.renderVSeparator(0)}
                        {this.renderPart1Mobile()}
                        {this.renderPart2Mobile()}
                        {Styles.renderVSeparator(30)}
                    </View>
                </ScrollView>
            </View >
        );
    }



    renderPart1 = () => {
    }



    renderPart1Mobile = () => {
        const NotificationsTypes = [
            { key: 'notify_whatsapp', title: STRINGS.notify_whatsapp, currentStatus: this.state.whatsappNotif },
            { key: 'notify_app', title: STRINGS.notify_app, currentStatus: this.state.appNotif },
        ];

        const toggleNotificationType = (key) => {
            // Toggle the corresponding state property
            switch (key) {
                case 'notify_whatsapp':
                    this.setState({ whatsappNotif: !this.state.whatsappNotif });
                    let whatsappNotif = !this.state.whatsappNotif ? 'Y' : 'N';
                    this.loadNotificationsSettings('', '', '', '', '', '', whatsappNotif, '');
                    break;
                case 'notify_app':
                    this.setState({ appNotif: !this.state.appNotif });
                    let appNotif = !this.state.appNotif ? 'Y' : 'N';
                    this.loadNotificationsSettings('', '', '', '', '', '', '', appNotif);
                    break;
                default:
                    break;
            }
        };

        NotificationsTypes.forEach(item => {
            item.icon = item.currentStatus ? checkBoxSelectedIcon : checkBoxIcon;
            item.onPress = () => toggleNotificationType(item.key);
        });

        return (
            <View>
                <View style={{
                    width: width - 20, marginHorizontal: 16,
                    justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#FFF', flexDirection: 'row', marginTop: 20
                }}>
                    <Text style={[AppStyles.notificationTextTitles]}>{STRINGS.turn_on_notifications}</Text>
                    {!this.state.turnNotificationsOn && (
                        <TouchableOpacity onPress={() => {
                            this.setState({ turnNotificationsOn: !this.state.turnNotificationsOn });
                            this.loadNotificationsSettings('Y', '', '', '', '', '', '', '');
                        }}>
                            <Image source={toggleIcon} style={{ width: 51, height: 31, marginVertical: 10, marginRight: 16 }} objectFit="contain" />
                        </TouchableOpacity>
                    )}
                    {this.state.turnNotificationsOn && (
                        <TouchableOpacity onPress={() => {
                            this.setState({ turnNotificationsOn: !this.state.turnNotificationsOn });
                            this.loadNotificationsSettings('N', '', '', '', '', '', '', '');
                        }}>
                            <Image source={toggleSelectedIcon} style={{ width: 50, height: 31, marginVertical: 10, marginRight: 16 }} objectFit="contain" />
                        </TouchableOpacity>
                    )}
                </View>
                <View style={{ width: width - 20, marginLeft: 50, flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', marginHorizontal: 32 }}>
                    {NotificationsTypes.map((item, index) => (
                        <View style={{ marginTop: 15 }}>
                            <TouchableOpacity key={index} onPress={item.onPress} style={{ width: '100%', paddingVertical: 10, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                    <Image source={item.icon} style={{ width: 24, height: 24, marginRight: 10 }} />
                                    <Text style={[AppStyles.notificationText, { fontSize: 16 }]}>{item.title}</Text>
                                </View>
                            </TouchableOpacity>
                            <Text style={[AppStyles.notificationText, { fontSize: 14, color: '#888', width: index === 1 ? width - 120 : width - 100 }]}>{item.description}</Text>
                        </View>
                    ))}
                </View>
            </View>
        )
    }

    renderPart2Mobile = () => {
        if (!this.state.selectedNotificationTypes) {
            this.state.selectedNotificationTypes = [];
        }

        const NotificationsTypes = [
            { key: 'order_notification_Related', title: STRINGS.order_notification_Related, description: STRINGS.order_notification_Related_description, currentStatus: this.state.relatedNotif },
            { key: 'product_stock_notification', title: STRINGS.product_stock_notification, description: STRINGS.product_stock_notification_description, currentStatus: this.state.stockNotif },
            { key: 'promotions_Bonuses_notification', title: STRINGS.promotions_Bonuses_notification, description: STRINGS.promotions_Bonuses_notification_description, currentStatus: this.state.promoNotif },
            { key: 'account_documents_notification', title: STRINGS.account_documents_notification, description: STRINGS.account_documents_notification_description, currentStatus: this.state.accountNotif },
            { key: 'critical_alert', title: STRINGS.critical_alert, description: STRINGS.clitical_alert_description, currentStatus: this.state.criticalAlert },
        ];

        const toggleNotificationType = (key) => {
            // Toggle the corresponding state property
            switch (key) {
                case 'order_notification_Related':
                    this.setState({ relatedNotif: !this.state.relatedNotif });
                    let relatedNotif = !this.state.relatedNotif ? 'Y' : 'N';
                    this.loadNotificationsSettings('', relatedNotif, '', '', '', '', '', '');
                    break;
                case 'product_stock_notification':
                    this.setState({ stockNotif: !this.state.stockNotif });
                    let stockNotif = !this.state.stockNotif ? 'Y' : 'N';
                    this.loadNotificationsSettings('', '', stockNotif, '', '', '', '', '');
                    break;
                case 'promotions_Bonuses_notification':
                    this.setState({ promoNotif: !this.state.promoNotif });
                    let promoNotif = !this.state.promoNotif ? 'Y' : 'N';
                    this.loadNotificationsSettings('', '', '', promoNotif, '', '', '', '');
                    break;
                case 'account_documents_notification':
                    this.setState({ accountNotif: !this.state.accountNotif });
                    let accountNotif = !this.state.accountNotif ? 'Y' : 'N';
                    this.loadNotificationsSettings('', '', '', '', accountNotif, '', '', '');
                    break;
                case 'critical_alert':
                    this.setState({ criticalAlert: !this.state.criticalAlert });
                    let criticalAlert = !this.state.criticalAlert ? 'Y' : 'N';
                    this.loadNotificationsSettings('', '', '', '', '', criticalAlert, '', '');
                    break;
                default:
                    break;
            }
        };

        // Render notification types
        NotificationsTypes.forEach(item => {
            item.icon = item.currentStatus ? checkBoxSelectedIcon : checkBoxIcon;
            item.onPress = () => toggleNotificationType(item.key);
        });
        return (
            <View style={{ marginHorizontal: 16 }}>
                <Text style={[AppStyles.notificationTextTitles, { marginTop: 20 }]}>
                    {STRINGS.notifications_type}
                </Text>
                <View style={{ width: width - 20, marginTop: 20, flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', marginHorizontal: 32 }}>
                    {NotificationsTypes.map((item, index) => (
                        <View style={{ marginTop: 15 }}>
                            <TouchableOpacity key={index} onPress={item.onPress} style={{ width: '100%', paddingVertical: 10, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                    <Image source={item.icon} style={{ width: 24, height: 24, marginRight: 10 }} />
                                    <Text style={[AppStyles.notificationText, { fontSize: 16 }]}>{item.title}</Text>
                                </View>
                            </TouchableOpacity>
                            <Text style={[AppStyles.notificationText, { fontSize: 14, color: '#888', width: index === 1 ? width - 120 : width - 100 }]}>{item.description}</Text>
                        </View>
                    ))}
                </View>
            </View>
        )
    }




    styles = () => ({
        container: {
            flex: 1,
            width: width,
            alignItems: "center",
            backgroundColor: WHITE
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            width,
            height: 590,
        }
    });
}



export default NotificationsSettings;
